import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const Download = () => {
  const location = useLocation();
  const sessionId = new URLSearchParams(location.search).get("session_id");

  useEffect(() => {
    const fetchDownload = async () => {
        try {
          const res = await fetch(`https://modularobjects.com/checkout/api/payment/download-model?session_id=${sessionId}`);
      
          if (!res.ok) {
            const text = await res.text();
            console.error("❌ Backend response:", text);
            throw new Error("Nije moguće preuzeti fajl.");
          }
      
          const blob = await res.blob();
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = "model.glb";
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
      
          // ✅ Dodaj redirect nakon preuzimanja
          setTimeout(() => {
            window.location.href = "/demo";
          }, 1500); // kratka pauza da fajl "krene" da se skida
        } catch (err) {
          console.error("❌ Greška pri preuzimanju:", err);
          alert("Greška pri preuzimanju fajla.");
        }
      };      
      

    if (sessionId) {
      fetchDownload();
    }
  }, [sessionId]);

  return <div className="p-6 text-center text-lg">🔁 Preparing download...</div>;
};

export default Download;
